import { MenuItemType } from 'types/cms';

export const getShopHeaderAccountItems = ({
  logout,
  notificationCount,
}: {
  logout: () => void;
  notificationCount: number | undefined;
}): MenuItemType[] => [
  {
    label: 'shop.shopProfile',
    href: '/profile/',
    acf: {
      icon: 'fa-classic fa-solid fa-shop',
    },
  },
  {
    label: 'shop.events',
    href: '/events/',
    acf: {
      icon: 'fa-classic fa-solid fa-calendar',
    },
  },
  {
    label: 'shop.shopCollection',
    href: '/cards?collection=true',
    acf: {
      icon: 'fa-classic fa-solid fa-dice-d20',
    },
  },
  {
    label: 'shop.shopNotifications',
    href: '/profile/notification/',
    count: notificationCount,
    acf: {
      action: 'notification',
      icon: 'fa-classic fa-solid fa-bell',
    },
  },
  {
    label: 'shop.accountParameters',
    href: '/manage-account/manage-shop/edit-shop-profile/',
    acf: {
      icon: 'fa-classic fa-solid fa-lock-keyhole',
    },
  },
  {
    label: 'shop.logout',
    onClick: logout,
    acf: {
      action: 'logout',
      icon: 'fa-classic fa-solid fa-door-open',
    },
  },
];
